import React from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarDays } from "lucide-react";
import { toast } from "sonner";
import { fmtDateShort } from "@/lib/format";

export const WEEKDAYS_IT = ["lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato", "domenica"];

export default function CalendarRevealCard() {
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ["calendar-reveal"],
    queryFn: async () => (await api.get("/school-config/calendar-reveal")).data,
  });
  const mut = useMutation({
    mutationFn: async (weekday) => (await api.put("/school-config/calendar-reveal", { weekday })).data,
    onSuccess: (d) => {
      qc.setQueryData(["calendar-reveal"], d);
      toast.success(`Settimana successiva visibile da ${WEEKDAYS_IT[d.weekday]}`);
    },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });
  return (
    <Card className="border border-stone-200 rounded-xl shadow-none overflow-hidden" data-testid="calendar-reveal-card">
      <div className="p-5 border-b border-stone-100 flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg grid place-items-center text-white bg-[#E2725B]"><CalendarDays size={18}/></div>
        <div className="flex-1">
          <div className="font-medium text-[#1C352D]">Calendario didattico — visibilità studenti</div>
          <div className="text-[11px] text-stone-500">Da quale giorno gli studenti vedono il calendario della settimana successiva (dalle 00:00).</div>
        </div>
      </div>
      <div className="p-5 flex flex-wrap items-end gap-4">
        <div className="w-56">
          <label className="text-[10px] uppercase tracking-widest text-stone-500">Visibile da</label>
          <Select value={data ? String(data.weekday) : ""} onValueChange={(v) => mut.mutate(Number(v))}>
            <SelectTrigger className="mt-1" data-testid="calendar-reveal-select"><SelectValue placeholder="…"/></SelectTrigger>
            <SelectContent>
              {WEEKDAYS_IT.map((d, i) => <SelectItem key={i} value={String(i)}>{d.charAt(0).toUpperCase() + d.slice(1)}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        {data && <div className="text-[12px] text-stone-600 pb-2" data-testid="calendar-reveal-current">Oggi gli studenti vedono fino a <b>{fmtDateShort(data.visible_until)}</b>.</div>}
      </div>
    </Card>
  );
}
